<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <div class="d-flex justify-content-between flex-wrap">
          <b-form-group label-for="filterInput" class="mb-0">
            <b-button
              variant="gradient-primary"
              size="sm"
              class="mr-1"
              @click="traerUsuarioTEA"
              :disabled="loading"
              v-b-tooltip.hover.v-dark
              title="Recargar"
            >
              <font-awesome-icon
                icon="fa-solid fa-arrows-rotate"
                :spin="loading"
              />
            </b-button>
            <!-- v-if="$can('create', 'Pr Man Lotes')" -->
            <b-button
              variant="gradient-primary"
              size="sm"
              class="mr-1"
              v-b-tooltip.hover.v-dark
              title="Nuevo usuario"
              @click="openModal()"
            >
              <font-awesome-icon icon="fa-solid fa-plus" />
            </b-button>

            <b-button
              variant="gradient-primary"
              size="sm"
              class="mr-1"
              @click="exportarExcel"
              v-b-tooltip.hover.v-dark
              title="Exportar Excel"
              :disabled="exporting"
            >
              <span v-if="exporting">
                <b-spinner small label="Spinning"></b-spinner>
              </span>
              <span v-else
                ><font-awesome-icon icon="fa-solid fa-file-excel"
              /></span>
            </b-button>
          </b-form-group>
          <b-form-group label-for="filterInput" class="mb-0">
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Buscar"
              />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">
                  Borrar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-card-body>
      <b-table
        hover
        responsive
        small
        class="position-relative"
        :per-page="perPage"
        :current-page="currentPage"
        :items="resultSet"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="cPaginacion"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell(opciones)="data">
          <div class="text-nowrap">
            <b-button
              pill
              size="sm"
              variant="outline-primary"
              @click="openModal(data.item)"
              style="border: 1px solid #25304600 !important"
            >
              <feather-icon icon="EditIcon" size="16"
            /></b-button>
            <b-button
              pill
              size="sm"
              variant="outline-primary"
              @click="deleteItem(data.item)"
              style="border: 1px solid #25304600 !important"
            >
              <feather-icon icon="TrashIcon" size="16"
            /></b-button>
          </div>
        </template>
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
          />
        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>
    <!--       @show="resetModal" -->
    <b-modal
      v-model="modalActive"
      :title="(id_edit != null ? 'Editar ' : 'Crear ') + 'Usuario'"
      no-close-on-backdrop
      centered
      size="lg"
      hide-footer
      ><div v-if="sending" align="center">
        <p>Procesando información ...</p>
        <b-spinner label="Loading..." variant="primary" />
      </div>
      <form v-else ref="form" @submit.stop.prevent="sendData">
        <b-form-group label="Código SAP"
          ><div role="group">
            <b-form-input
              v-model="codigo_sap"
              :state="codigo_sapState"
              aria-describedby="input-live-help input-live-feedback"
              placeholder="Ingresa el código SAP"
              trim
              :readonly="id_edit != null"
            />
            <b-form-invalid-feedback id="input-live-feedback">
              Campo obligatorio
            </b-form-invalid-feedback>
          </div>
        </b-form-group>
        <b-form-group label="DNI"
          ><div role="group">
            <b-form-input
              v-model="dni"
              :state="dniState"
              aria-describedby="input-live-help input-live-feedback"
              placeholder="Ingresa un DNI"
              trim
              :readonly="id_edit != null"
              maxlength="8"
            />
            <b-form-invalid-feedback id="input-live-feedback">
              Campo obligatorio
            </b-form-invalid-feedback>
          </div>
        </b-form-group>
        <b-form-group label="Nombres"
          ><div role="group">
            <b-form-input
              v-model="nombres"
              :state="nombreState"
              aria-describedby="input-live-help input-live-feedback"
              placeholder="Ingresa un nombre"
              trim
            />
            <b-form-invalid-feedback id="input-live-feedback">
              Campo obligatorio
            </b-form-invalid-feedback>
          </div>
        </b-form-group>
        <b-form-group label="Apellidos"
          ><div role="group">
            <b-form-input
              v-model="apellidos"
              :state="apellidoState"
              aria-describedby="input-live-help input-live-feedback"
              placeholder="Ingresa un apellido"
              trim
            />
            <b-form-invalid-feedback id="input-live-feedback">
              Campo obligatorio
            </b-form-invalid-feedback>
          </div>
        </b-form-group>
        <div>
          <b-form-checkbox v-model="estado" name="check-button" switch>
            {{ estado ? "Activo" : "Inactivo" }}
          </b-form-checkbox>
        </div>
      </form>
      <div v-if="!sending" class="w-100 my-2 pb-2">
        <button
          slot="modal-footer-cancel"
          class="btn btn-secondary float-left"
          @click="modalActive = false"
        >
          Cancelar
        </button>
        <button
          slot="modal-footer-ok"
          class="btn btn-primary float-right"
          @click="sendData"
        >
          Enviar
        </button>
      </div>
    </b-modal>
    <b-modal
      v-model="modalDeleteActive"
      title="Eliminar Usuario"
      no-close-on-backdrop
      centered
      size="sm"
      hide-footer
      ><div v-if="sending" align="center">
        <p>Procesando eliminacion ...</p>
        <b-spinner label="Loading..." variant="primary" />
      </div>
      <div v-else>
        ¿Seguro de eliminar al usuario
        {{
          item_delete != null
            ? item_delete.codigo_sap +
              " | " +
              item_delete.nombres +
              " " +
              item_delete.apellidos
            : ""
        }}?
      </div>
      <div v-if="!sending" class="w-100 my-2 pb-2">
        <button
          size="sm"
          slot="modal-footer-cancel"
          class="btn btn-secondary float-left"
          @click="modalDeleteActive = false"
        >
          Cancelar
        </button>
        <button
          size="sm"
          slot="modal-footer-ok"
          class="btn btn-primary float-right"
          @click="sendDelete"
        >
          Eliminar
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import axiosIns from "../../libs/axios";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BTable,
  BSpinner,
  BInputGroup,
  BFormGroup,
  BFormSelect,
  BPagination,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormInput,
  VBTooltip,
  BTooltip,
  BBadge,
  BModal,
  BFormInvalidFeedback,
  BFormText,
  BFormCheckbox,
} from "bootstrap-vue";
export default {
  components: {
    BTable,
    BSpinner,
    BInputGroup,
    BFormGroup,
    BFormSelect,
    BPagination,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormInput,
    BBadge,
    BTooltip,
    BModal,
    BFormInvalidFeedback,
    BFormText,
    BFormCheckbox,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      fields: [
        {
          key: "opciones",
          label: "Opciones ",
          class: "text-center ",
          stickyColumn: true,
        },
        {
          key: "codigo_sap",
          label: "Código SAP",
          sortable: true,
        },
        {
          key: "dni",
          label: "DNI",
          sortable: true,
        },
        {
          key: "nombres",
          label: "Nombres",
          sortable: true,
        },
        {
          key: "apellidos",
          label: "Apellidos",
          sortable: true,
        },
        {
          key: "estado",
          label: "Estado",
          sortable: true,
        },
      ],

      resultSet: [],
      loading: false,
      perPage: 15,
      pageOptions: [15, 25, 50],
      currentPage: 1,
      totalRows: 1,
      sortBy: "id",
      sortDesc: true,
      sortDirection: "desc",
      filter: null,
      filterOn: [],
      status: [
        {
          true: "Activo",
          false: "Inactivo",
        },
        {
          true: "light-success",
          false: "light-danger",
        },
      ],
      exporting: false,

      modalActive: false,
      id_edit: null,
      codigo_sap: "",
      dni: "",
      nombres: "",
      apellidos: "",
      estado: false,
      sending: false,
      item_delete: null,
      modalDeleteActive: false,
    };
  },
  mounted() {
    this.traerUsuarioTEA();
  },
  methods: {
    deleteItem(item) {
      this.item_delete = item;
      this.modalDeleteActive = true;
    },
    sendDelete() {
      const yo = this;
      yo.sending = true;
      const config = {
        method: "DELETE",
        url: "trabajaenagrovision/usuariostea/eliminar/" + this.item_delete.id,
        headers: {
          "Content-Type": "application/json",
        },
      };
      axiosIns(config)
        .then(function (response) {
          if (response.status === 204) {
            yo.mostrarNotificacion(
              "¡Bien hecho!",
              "CheckIcon",
              "El registro se eliminó correctamente.",
              "success",
              5000
            );
            yo.traerUsuarioTEA();
            yo.modalDeleteActive = false;
            yo.resetModal();
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.mostrarNotificacion(
            "Ocurrio un error.",
            "BellIcon",
            error.toString(),
            "danger",
            5000
          );
        })
        .finally(function () {
          yo.sending = false;
        });
    },
    resetModal() {
      this.codigo_sap = "";
      this.dni = "";
      this.nombres = "";
      this.apellidos = "";
      this.estado = false;
      this.id_edit = null;
      this.item_delete = null;
    },
    validate() {
      if (this.codigo_sap.replace(/\s+/g, "").length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Datos incompletos",
            icon: "AlertTriangleIcon",
            text: "Complete el campo para el código SAP.",
            variant: "warning",
          },
        });
        return false;
      }
      if (this.dni.replace(/\s+/g, "").length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Datos incompletos",
            icon: "AlertTriangleIcon",
            text: "Complete el campo para el DNI.",
            variant: "warning",
          },
        });
        return false;
      }
      if (this.nombres.replace(/\s+/g, "").length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Datos incompletos",
            icon: "AlertTriangleIcon",
            text: "Complete el campo para los nombres.",
            variant: "warning",
          },
        });
        return false;
      }
      if (this.apellidos.replace(/\s+/g, "").length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Datos incompletos",
            icon: "AlertTriangleIcon",
            text: "Complete el campo para los apellidos.",
            variant: "warning",
          },
        });
        return false;
      }
      return true;
    },
    mostrarNotificacion(titulo, icono, texto, variante, tiempo) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: titulo,
            icon: icono,
            text: texto,
            variant: variante,
          },
        },
        {
          timeout: tiempo,
          position: "top-center",
        }
      );
    },
    sendData(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (!this.validate()) {
        return;
      }
      const yo = this;
      yo.sending = true;
      const data = JSON.stringify({
        dni: yo.dni,
        nombres: yo.nombres,
        apellidos: yo.apellidos,
        codigo_sap: yo.codigo_sap,
        estado: yo.estado,
      });
      const config = {
        method: this.id_edit == null ? "POST" : "PUT",
        url: `trabajaenagrovision/usuariostea/${
          this.id_edit == null ? "crear/" : "editar/" + this.id_edit
        }`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axiosIns(config)
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            yo.mostrarNotificacion(
              "¡Bien hecho!",
              "CheckIcon",
              `El registro se ${
                yo.id_edit == null ? "creó" : "editó"
              } correctamente.`,
              "success",
              5000
            );
            yo.traerUsuarioTEA();
            yo.modalActive = false;
            yo.resetModal();
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.mostrarNotificacion(
            "Ocurrio un error.",
            "BellIcon",
            error.toString(),
            "danger",
            5000
          );
        })
        .finally(function () {
          yo.sending = false;
        });
    },
    openModal(item = null) {
      this.resetModal();
      this.modalActive = true;
      if (item != null) {
        this.id_edit = item.id;
        this.codigo_sap = item.codigo_sap;
        this.dni = item.dni;
        this.nombres = item.nombres;
        this.apellidos = item.apellidos;
        this.estado = item.estado;
      }
    },
    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    traerUsuarioTEA() {
      var yo = this;
      yo.loading = true;

      var config = {
        method: "get",
        url: `/trabajaenagrovision/usuariostea/`,
      };

      axiosIns(config)
        .then(function (response) {
          yo.resultSet = response.data;
          yo.totalRows = yo.resultSet.length;
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          yo.loading = false;
        });
    },
    exportarExcel() {
      var yo = this;
      this.exporting = true;
      var config = {
        method: "GET",
        url: `/trabajaenagrovision/usuariostea/exportar/`,
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "arraybuffer",
      };

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "Usuarios TEA.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();

            yo.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Archivo creado",
                  icon: "CheckIcon",
                  text: "El archivo se creó satisfactoriamente.",
                  variant: "success",
                },
              },
              {
                position: "top-center",
              }
            );
          } else if (response.status === 204) {
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: "No existen registros",
                icon: "AlertTriangleIcon",
                text: "No se encontraron registros con los parámetros solicitados.",
                variant: "warning",
              },
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toast({
            component: ToastificationContent,
            props: {
              title: "Error en la creación del archivo",
              icon: "XIcon",
              text: "Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.",
              variant: "danger",
            },
          });
        })
        .finally(function () {
          yo.exporting = false;
        });
    },
  },
  computed: {
    codigo_sapState() {
      this.codigo_sap = this.codigo_sap.replace(/\s+/g, "");
      return this.codigo_sap.length > 7 ? true : false;
    },
    dniState() {
      this.dni = this.dni.replace(/\s+/g, "");
      return this.dni.length > 7 ? true : false;
    },
    nombreState() {
      return this.nombres.length > 2 ? true : false;
    },
    apellidoState() {
      return this.apellidos.length > 2 ? true : false;
    },
  },
};
</script>
